import React, { useContext, useState } from "react";
import { ContentContext } from "@/pages/Layout";
import { mediaUrl } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { Mail, Phone, MapPin, Instagram } from "lucide-react";
import RegisterDialog from "@/components/RegisterDialog";

export default function Contact() {
  const content = useContext(ContentContext);
  const { t } = useApp();
  const [open, setOpen] = useState(false);
  const c = content?.contact || {};

  const rows = [
    [MapPin, t("address"), c.address],
    [Phone, t("phone"), c.phone],
    [Mail, t("email"), c.email],
    [Instagram, "Instagram", c.instagram],
  ];

  return (
    <div data-testid="contact-page" className="px-6 md:px-12 py-20 md:py-28">
      <div className="max-w-[1600px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-16">
        <div className="md:col-span-6">
          <p className="overline">{t("contactUs")}</p>
          <h1 className="font-serif text-4xl sm:text-6xl text-white mt-4">{t("contact")}</h1>
          <div className="gold-line mt-8 w-40" />

          <div className="mt-14 flex flex-col gap-9">
            {rows.filter(([, , v]) => v).map(([Icon, label, value], i) => (
              <div key={label} data-testid={`contact-row-${i}`} className="flex gap-5 items-start">
                <div className="w-10 h-10 border border-white/10 flex items-center justify-center shrink-0">
                  <Icon size={15} className="text-gold" />
                </div>
                <div>
                  <p className="text-[0.62rem] uppercase tracking-[0.22em] text-neutral-500">{label}</p>
                  <p className="text-base text-neutral-200 mt-1.5 break-all">{value}</p>
                </div>
              </div>
            ))}
          </div>

          <button data-testid="contact-register-btn" onClick={() => setOpen(true)}
            className="mt-14 bg-gold text-black px-9 py-3.5 text-[0.72rem] uppercase tracking-[0.24em] font-medium hover:bg-white transition-colors duration-300">
            {t("register")}
          </button>
        </div>

        <div className="md:col-span-6">
          <div className="aspect-[4/5] overflow-hidden border border-white/5 bg-[#0c0c0c]">
            {(c.image || content?.covers?.contact) && (
              <img src={mediaUrl(c.image || content?.covers?.contact)}
                alt="" className="w-full h-full object-cover" />
            )}
          </div>
        </div>
      </div>
      <RegisterDialog open={open} onOpenChange={setOpen} />
    </div>
  );
}
